module.exports = __webpack_public_path__ + "img/shipo-menu-barge-performance-white.10235d5a.svg";